import { createContext, useContext } from 'react'

interface TableFiltersContextType<T, F> {
  selectedRows: T[]
  filters: F
  handleSearch: () => void
  setFilters: React.Dispatch<React.SetStateAction<F>>
  rowCount: number
  rowsLoading: boolean
  handleDeleteFilter: (key: keyof F) => void
  handleClearAllFilters: () => void
  syncFiltering: () => void
}

export function createDataTableFiltersContext<T, F>() {
  const defaultContext: TableFiltersContextType<T, F> = {
    selectedRows: [],
    filters: {} as F,
    handleSearch: () => {},
    setFilters: () => {},
    rowCount: 0,
    rowsLoading: false,
    handleDeleteFilter: () => {},
    handleClearAllFilters: () => {},
    syncFiltering: () => {},
  }

  const Context = createContext<TableFiltersContextType<T, F>>(defaultContext)

  function useDataTableFiltersContext() {
    return useContext(Context)
  }

  return { Context, useDataTableFiltersContext }
}
